import { useStaticQuery, graphql } from 'gatsby'

export const useGetAllStoresFromGatsby = () => {
  const data = useStaticQuery(graphql`
    query {
      allStores {
        nodes {
          location {
            latitude
            longitude
          }
          address {
            addressLine1
            addressLine2
            city
            country
            county
            postcode
          }
          serviceHighlights {
            name
            priority
            serviceName
          }
          storeName
          name
          storeType
          storeFormat
          region
          pharmacy {
            ExtensionValue
          }
          convenience {
            ExtensionValue
          }
          openingTimes {
            close
            day
            day_short
            open
            day_id
          }
          linkedLocations {
            openingTimes {
              close
              day
              day_id
              day_short
              open
            }
            name
            location {
              latitude
              longitude
            }
            category
            telephone
            storeName
            storeFormat
          }
          services {
            name
            serviceName
          }
          departments {
            openingTimes {
              close
              day
              day_short
              day_id
              open
            }
            name
            serviceName
          }
          specialOpeningTimes {
            name
            specialOpeningTimes {
              close
              closed
              date
              label
              open
            }
          }
        }
      }
    }
  `)

  return data?.allStores?.nodes
}
